export default "__VITE_ASSET__0de9660c__"